import steps__slider_main_item_icon_1 from "../../../../../img/steps__slider-main-item-icon-1.svg";
import steps__slider_main_item_icon_2 from "../../../../../img/steps__slider-main-item-icon-2.svg";
import steps__slider_main_item_icon_3 from "../../../../../img/steps__slider-main-item-icon-3.svg";
import steps__slider_main_item_icon_little_1 from "../../../../../img/steps__slider-main-item-icon-little-1.svg";
import steps__slider_main_item_icon_little_2 from "../../../../../img/steps__slider-main-item-icon-little-2.svg";
import steps__slider_main_item_icon_little_3 from "../../../../../img/steps__slider-main-item-icon-little-3.svg";
import steps__slider_main_item_icon_little_4 from "../../../../../img/steps__slider-main-item-icon-little-4.svg";
import steps__slider_main_item_icon_little_5 from "../../../../../img/steps__slider-main-item-icon-little-5.svg";
import steps__slider_main_item_icon_little_6 from "../../../../../img/steps__slider-main-item-icon-little-6.svg";
import steps__slider_main_item_icon_little_7 from "../../../../../img/steps__slider-main-item-icon-little-7.svg";
import steps__slider_main_item_icon_little_8 from "../../../../../img/steps__slider-main-item-icon-little-8.svg";
import steps__slider_img_1 from "../../../../../img/steps__slider-img-1.png";
import steps__slider_img_2 from "../../../../../img/steps__slider-img-2.png";
import steps__slider_img_3 from "../../../../../img/steps__slider-img-3.png";
import steps__slider_img_4 from "../../../../../img/steps__slider-img-4.png";

export const localState = [
  {
    id: 1,
    steps__slider_img: steps__slider_img_1,
    blocks: [
      {
        id: 1,
        grit_color_class: "grit--orange",
        text_color_class: "steps__slider-main-item-heading--orange",
        delay: 100,
        img_steps__slider: steps__slider_main_item_icon_1,
        icon_little: steps__slider_main_item_icon_little_1,
      },
    ],
  },
  {
    id: 2,
    steps__slider_img: steps__slider_img_2,
    blocks: [
      {
        id: 1,
        grit_color_class: "grit--orange",
        text_color_class: "steps__slider-main-item-heading--orange",
        delay: 100,
        img_steps__slider: steps__slider_main_item_icon_1,
        icon_little: steps__slider_main_item_icon_little_2,
      },
      {
        id: 2,
        grit_color_class: "grit--pink",
        text_color_class: "steps__slider-main-item-heading--pink",
        delay: 500,
        img_steps__slider: steps__slider_main_item_icon_2,
        icon_little: steps__slider_main_item_icon_little_3,
      },
    ],
  },
  {
    id: 3,
    steps__slider_img: steps__slider_img_3,
    blocks: [
      {
        id: 1,
        grit_color_class: "grit--orange",
        text_color_class: "steps__slider-main-item-heading--orange",
        delay: 100,
        img_steps__slider: steps__slider_main_item_icon_1,
        icon_little: steps__slider_main_item_icon_little_4,
      },
      {
        id: 2,
        grit_color_class: "grit--pink",
        text_color_class: "steps__slider-main-item-heading--pink",
        delay: 500,
        img_steps__slider: steps__slider_main_item_icon_2,
        icon_little: steps__slider_main_item_icon_little_5,
      },
    ],
  },
  {
    id: 4,
    steps__slider_img: steps__slider_img_4,
    blocks: [
      {
        id: 1,
        grit_color_class: "grit--orange",
        text_color_class: "steps__slider-main-item-heading--orange",
        delay: 100,
        img_steps__slider: steps__slider_main_item_icon_1,
        icon_little: steps__slider_main_item_icon_little_6,
      },
      {
        id: 2,
        grit_color_class: "grit--pink",
        text_color_class: "steps__slider-main-item-heading--pink",
        delay: 500,
        img_steps__slider: steps__slider_main_item_icon_2,
        icon_little: steps__slider_main_item_icon_little_7,
      },
      {
        id: 3,
        grit_color_class: "grit--dark-blue",
        text_color_class: "steps__slider-main-item-heading--dark-blue",
        delay: 900,
        img_steps__slider: steps__slider_main_item_icon_3,
        icon_little: steps__slider_main_item_icon_little_8,
      },
    ],
  },
];
